import type {ValueEditorOptions} from '../../../kp-value-editor/types';
import type {TextValueEditorValidations} from '../text/types';
import type {CommonValueEditorLocalizations} from '../_shared/common-types';

export type TextWithMetadataValueEditorOptions = ValueEditorOptions & {
    excludedExtensions?: TextWithMetadataValueEditorModelExtension[];
}

export interface TextWithMetadataValueEditorLocalizations extends CommonValueEditorLocalizations {
    startsWith: string;
    wholeStartsWith: string;
    equals: string;
    equalsWords: string;
    metadataSelectLabel: string;
    currentSelectValue: string;
    mainInputLabel: string;
}

export enum TextWithMetadataValueEditorModelExtension {
    STARTS_WITH = 'startsWith',
    WHOLE_STARTS_WITH = 'wholeStartsWith',
    EQUALS_WORDS = 'equalsWords',
    EQUALS = 'equals'
}

export interface TextWithMetadataValueEditorModel {
    extension: TextWithMetadataValueEditorModelExtension;
    row: string;
}

export interface TextWithMetadataValueEditorTypeMap {
    'text-with-metadata': {
        options: TextWithMetadataValueEditorOptions,
        validations: TextValueEditorValidations,
        localizations: TextWithMetadataValueEditorLocalizations
    };
}